import { render, staticRenderFns } from "./section-title-index.vue?vue&type=template&id=6233aade&scoped=true"
import script from "./section-title-index.vue?vue&type=script&lang=js"
export * from "./section-title-index.vue?vue&type=script&lang=js"
import style0 from "./section-title-index.vue?vue&type=style&index=0&id=6233aade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233aade",
  null
  
)

export default component.exports